module.exports = __webpack_public_path__ + "static/media/laMediatica.d8ca086f.png";